import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import { connect } from 'react-redux';
import withEndpointAuthorization from '../../../authorization/withEndPointAuthorization';
import { patchDeleteTripFromItinerary } from '../../../../../actions';
import { generateDeleteTripFromItineraryEndpoint } from '../../../../../config/endpoints';
import { DELETE } from '../../../../../config/permissions';
import DeleteTripForm from './DeleteTripForm';
import Modal from '../../../../common/modal/Modal';

export const DeleteTripButton = ({
  itineraryId,
  dispatchPatchDeleteTripFromItinerary,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [modalBody, setModalBody] = useState('');

  const onModalSubmit = ({ observation }) => {
    dispatchPatchDeleteTripFromItinerary(itineraryId, {
      observation,
    });
  };
  const openModal = () => {
    setShowModal(true);
  };

  const closeModal = () => setShowModal(false);

  const buildModalBody = () => {
    const newModalBody = (
      <DeleteTripForm onCancel={closeModal} handleProcess={onModalSubmit} />
    );
    setModalBody(newModalBody);
  };

  useEffect(() => {
    if (showModal !== false) {
      buildModalBody();
    }
  }, [showModal]);

  return (
    <>
      <Modal show={showModal} title="Liberar Bus" body={modalBody} size="lg" />
      <Button color="danger" className="border" onClick={openModal}>
        <i className="fa fa-times" /> Liberar bus
      </Button>
    </>
  );
};

DeleteTripButton.propTypes = {
  itineraryId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  dispatchPatchDeleteTripFromItinerary: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  dispatchPatchDeleteTripFromItinerary: patchDeleteTripFromItinerary,
};

const connectedComponent = connect(null, mapDispatchToProps)(DeleteTripButton);

export default withEndpointAuthorization({
  url: generateDeleteTripFromItineraryEndpoint(),
  mapUrlParamsToProps: { itineraryId: 'itineraryId' },
  permissionType: DELETE,
})(connectedComponent);
